import React from 'react';

function Resume() {
    const resumePath = "/images/Alex%20Vickrey%20-%20Website%20Resume.pdf";
    
    return (
        <div className="flex flex-col items-center justify-center min-h-screen px-4 py-8">
            <h1 className="text-4xl font-bold mb-4">General Resume</h1>
            <p className="text-lg text-gray-200 max-w-3xl text-center mb-8">
                Please note that the resume provided here offers a broad overview of my background. For specific opportunities, I adapt my resume to highlight the most relevant experience and more accurately reflect my alignment with the requirements of the role.
            </p>
            <div className="w-full max-w-5xl bg-gray-800 rounded-lg shadow-lg p-4">
                <iframe
                    src={resumePath}
                    className="w-full h-[80vh] rounded bg-white"
                    title="Alex Vickrey Resume"
                    style={{ border: 'none' }}
                >
                    <p>Your browser does not support PDFs. Please download the PDF to view it: <a href={resumePath}>Download PDF</a></p>
                </iframe>
            </div>
            <div className="mt-6">
                <a
                    href={resumePath}
                    download="Alex_Vickrey_Resume.pdf"
                    className="bg-cyan-600 hover:bg-cyan-700 text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-200"
                >
                    Download Resume (PDF)
                </a>
            </div>
        </div>
    );
}

export default Resume;
